import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullScreenCarouselComponent } from './full-screen-carousel/full-screen-carousel.component';
import { InlineCarouselComponent } from './inline-carousel/inline-carousel.component';
import { SwiperModule } from 'swiper/angular';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Lazy } from 'swiper';
import { IconModule } from "app/modules/icon/icon.module";

// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Lazy]);

@NgModule({
  imports: [
    CommonModule,
    IconModule,
    SwiperModule
  ],
  providers: [],
  declarations: [
    FullScreenCarouselComponent,
    InlineCarouselComponent,
  ],
  exports: [
    FullScreenCarouselComponent,
    InlineCarouselComponent
  ]
})
export class MediaModule { }
